{
    "$schema": "http://json-schema.org/draft-07/schema#",
    "definitions": {
        "AttachmentIngestEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "mimeType": {
                    "$ref": "#/definitions/AttachmentMIMEType"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "attachmentIngest"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "mimeType",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "AttachmentMIMEType": {
            "enum": [
                "image/jpeg",
                "image/png",
                "image/svg+xml"
            ],
            "type": "string"
        },
        "ClozeTaskContent": {
            "additionalProperties": false,
            "properties": {
                "body": {
                    "$ref": "#/definitions/TaskContentField"
                },
                "components": {
                    "additionalProperties": {
                        "$ref": "#/definitions/ClozeTaskContentComponent"
                    },
                    "type": "object"
                },
                "type": {
                    "enum": [
                        "cloze"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "body",
                "components",
                "type"
            ],
            "type": "object"
        },
        "ClozeTaskContentComponent": {
            "additionalProperties": false,
            "properties": {
                "order": {
                    "type": "number"
                },
                "ranges": {
                    "items": {
                        "additionalProperties": false,
                        "properties": {
                            "hint": {
                                "type": [
                                    "null",
                                    "string"
                                ]
                            },
                            "length": {
                                "type": "number"
                            },
                            "startIndex": {
                                "type": "number"
                            }
                        },
                        "required": [
                            "hint",
                            "length",
                            "startIndex"
                        ],
                        "type": "object"
                    },
                    "type": "array"
                }
            },
            "required": [
                "order",
                "ranges"
            ],
            "type": "object"
        },
        "PlainTaskContent": {
            "additionalProperties": false,
            "properties": {
                "body": {
                    "$ref": "#/definitions/TaskContentField"
                },
                "type": {
                    "enum": [
                        "plain"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "body",
                "type"
            ],
            "type": "object"
        },
        "QATaskContent": {
            "additionalProperties": false,
            "properties": {
                "answer": {
                    "$ref": "#/definitions/TaskContentField"
                },
                "body": {
                    "$ref": "#/definitions/TaskContentField"
                },
                "type": {
                    "enum": [
                        "qa"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "answer",
                "body",
                "type"
            ],
            "type": "object"
        },
        "TaskContentField": {
            "additionalProperties": false,
            "properties": {
                "attachments": {
                    "items": {
                        "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                        "type": "string"
                    },
                    "type": "array"
                },
                "text": {
                    "type": "string"
                }
            },
            "required": [
                "attachments",
                "text"
            ],
            "type": "object"
        },
        "TaskIngestEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "metadata": {
                    "additionalProperties": {
                        "type": "string"
                    },
                    "type": "object"
                },
                "provenance": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/TaskProvenance"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "spec": {
                    "$ref": "#/definitions/TaskSpec<TaskContent>"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskIngest"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "provenance",
                "spec",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskProvenance": {
            "additionalProperties": false,
            "properties": {
                "colorPaletteName": {
                    "enum": [
                        "blue",
                        "brown",
                        "cream",
                        "cyan",
                        "green",
                        "lime",
                        "orange",
                        "pink",
                        "purple",
                        "red",
                        "turquoise",
                        "violet",
                        "yellow"
                    ],
                    "type": "string"
                },
                "containerTitle": {
                    "type": "string"
                },
                "identifier": {
                    "type": "string"
                },
                "selectors": {
                    "items": {
                        "anyOf": [
                            {
                                "$ref": "#/definitions/TaskProvenanceRangeSelector"
                            },
                            {
                                "$ref": "#/definitions/TaskProvenanceTextPositionSelector"
                            },
                            {
                                "$ref": "#/definitions/TaskProvenanceTextQuoteSelector"
                            },
                            {
                                "$ref": "#/definitions/TaskProvenanceXPathSelector"
                            }
                        ]
                    },
                    "type": "array"
                },
                "title": {
                    "type": "string"
                },
                "url": {
                    "type": "string"
                }
            },
            "required": [
                "identifier"
            ],
            "type": "object"
        },
        "TaskProvenanceRangeSelector": {
            "additionalProperties": false,
            "properties": {
                "endSelector": {
                    "$ref": "#/definitions/TaskProvenanceXPathSelector"
                },
                "startSelector": {
                    "$ref": "#/definitions/TaskProvenanceXPathSelector"
                },
                "type": {
                    "enum": [
                        "RangeSelector"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "endSelector",
                "startSelector",
                "type"
            ],
            "type": "object"
        },
        "TaskProvenanceTextPositionSelector": {
            "additionalProperties": false,
            "properties": {
                "end": {
                    "type": "number"
                },
                "start": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "TextPositionSelector"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "end",
                "start",
                "type"
            ],
            "type": "object"
        },
        "TaskProvenanceTextQuoteSelector": {
            "additionalProperties": false,
            "properties": {
                "exact": {
                    "type": "string"
                },
                "prefix": {
                    "type": "string"
                },
                "suffix": {
                    "type": "string"
                },
                "type": {
                    "enum": [
                        "TextQuoteSelector"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "exact",
                "prefix",
                "suffix",
                "type"
            ],
            "type": "object"
        },
        "TaskProvenanceXPathSelector": {
            "additionalProperties": false,
            "properties": {
                "refinedBy": {
                    "$ref": "#/definitions/TaskProvenanceTextPositionSelector"
                },
                "type": {
                    "enum": [
                        "XPathSelector"
                    ],
                    "type": "string"
                },
                "value": {
                    "type": "string"
                }
            },
            "required": [
                "refinedBy",
                "type",
                "value"
            ],
            "type": "object"
        },
        "TaskRepetitionEvent": {
            "additionalProperties": false,
            "properties": {
                "componentID": {
                    "type": "string"
                },
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "outcome": {
                    "$ref": "#/definitions/TaskRepetitionOutcome"
                },
                "reviewSessionID": {
                    "type": "string"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskRepetition"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "componentID",
                "entityID",
                "id",
                "outcome",
                "reviewSessionID",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskRepetitionOutcome": {
            "enum": [
                "forgotten",
                "remembered",
                "skipped"
            ],
            "type": "string"
        },
        "TaskRescheduleEvent": {
            "additionalProperties": false,
            "properties": {
                "componentID": {
                    "type": "string"
                },
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "newDueTimestampMillis": {
                    "type": "number"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskReschedule"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "componentID",
                "entityID",
                "id",
                "newDueTimestampMillis",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskSpec<TaskContent>": {
            "additionalProperties": false,
            "properties": {
                "content": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/QATaskContent"
                        },
                        {
                            "$ref": "#/definitions/ClozeTaskContent"
                        },
                        {
                            "$ref": "#/definitions/PlainTaskContent"
                        }
                    ]
                },
                "type": {
                    "enum": [
                        "memory"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "content",
                "type"
            ],
            "type": "object"
        },
        "TaskUpdateDeletedEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "isDeleted": {
                    "type": "boolean"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskUpdatedDeleted"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "isDeleted",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskUpdateMetadataEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "metadata": {
                    "additionalProperties": {
                        "type": "string"
                    },
                    "type": "object"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskUpdateMetadata"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "metadata",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskUpdateProvenanceEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "provenance": {
                    "anyOf": [
                        {
                            "$ref": "#/definitions/TaskProvenance"
                        },
                        {
                            "type": "null"
                        }
                    ]
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskUpdateProvenanceEvent"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "provenance",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        },
        "TaskUpdateSpecEvent": {
            "additionalProperties": false,
            "properties": {
                "entityID": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "id": {
                    "pattern": "^[0-9a-zA-Z_\\-]{22}$",
                    "type": "string"
                },
                "spec": {
                    "$ref": "#/definitions/TaskSpec<TaskContent>"
                },
                "timestampMillis": {
                    "type": "number"
                },
                "type": {
                    "enum": [
                        "taskUpdateSpec"
                    ],
                    "type": "string"
                }
            },
            "required": [
                "entityID",
                "id",
                "spec",
                "timestampMillis",
                "type"
            ],
            "type": "object"
        }
    },
    "items": {
        "anyOf": [
            {
                "$ref": "#/definitions/TaskIngestEvent"
            },
            {
                "$ref": "#/definitions/TaskRepetitionEvent"
            },
            {
                "$ref": "#/definitions/TaskRescheduleEvent"
            },
            {
                "$ref": "#/definitions/TaskUpdateDeletedEvent"
            },
            {
                "$ref": "#/definitions/TaskUpdateSpecEvent"
            },
            {
                "$ref": "#/definitions/TaskUpdateProvenanceEvent"
            },
            {
                "$ref": "#/definitions/TaskUpdateMetadataEvent"
            },
            {
                "$ref": "#/definitions/AttachmentIngestEvent"
            }
        ]
    },
    "type": "array"
}
